<template>
  <md-dialog
    :md-active.sync="isVisible"
    :md-backdrop="true"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
  >
    <md-dialog-title>Export</md-dialog-title>

    <md-dialog-content>
      <div v-if="!inProgress && !isComplete">
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
        <div>Fetching records metadata...</div>
      </div>

      <div v-else-if="inProgress && meta.total">
        <md-progress-bar md-mode="determinate" :md-value="progress"></md-progress-bar>
        <div v-if="!isComplete">
          Downloaded {{commaNumber(records.length) || 0}} records of {{commaNumber(meta.total)}}.
        </div>
        <div v-else>Download complete!</div>
      </div>

      <div v-else-if="inProgress && !meta.total">
        <md-progress-bar v-if="!isComplete" md-mode="indeterminate"></md-progress-bar>
        <md-progress-bar v-if="isComplete" md-mode="determinate" :md-value="100"></md-progress-bar>
        <div v-if="!isComplete">
          Downloaded {{commaNumber(records.length) || 0}} records of many.
        </div>
        <div v-else>Download complete!</div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <vue-csv-downloader v-if="isComplete"
        :data="records"
        :download-name="filename"
        :fields="fields">
        Download
      </vue-csv-downloader>
      <md-button class="md-accent" @click="close()">Cancel</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import VueCsvDownloader from 'vue-csv-downloader';
import { formatToken, commaNumber, formatAmount } from '../utils/Formatter.util';

export default {
  name: 'export-modal',
  props: ['fields', 'onStart', 'onFetchData', 'specialPhones'],
  components: {
    VueCsvDownloader,
  },
  async updated() {
    if (this.isVisible && !this.inProgress) {
      if (this.onStart) {
        this.meta = await this.onStart();
      }
      this.inProgress = true;
      this.loadData();
    }
  },
  computed: {
    records() {
      return this.payload;
    },
    progress() {
      return this.meta.total ? (this.payload.length / this.meta.total) * 100 : 0;
    },
  },
  data() {
    return {
      isVisible: false,
      page: 1,
      meta: {
        total: 0,
        pages: 0,
      },
      isComplete: false,
      inProgress: false,
      payload: [],
      snackBar: {
        show: false,
        message: null,
      },
      filename: 'export',
    };
  },
  methods: {
    commaNumber,
    getExportFileName() {
      const filename = this.$parent.getExportFileName();
      this.filename = filename;
    },
    open() {
      this.isVisible = true;
      this.inProgress = false;
      this.page = 1;
      this.isComplete = false;
      this.meta = {};
      this.payload = [];
    },
    close() {
      this.isVisible = false;
    },

    formatVendResponse(data) {
      if (data.order_id) {
        data.ref = data.ref ? data.ref.toLocaleString('fullwide', { useGrouping: false }) : null;
        data.order_id = `'${data.order_id}`;
        data.meter_no = `'${data.meter_no}`;
        if (data.vendResponse) {
          data.rct_num = data.vendResponse.rct_num;
          data.units = data.vendResponse.units;
          data.amt = data.vendResponse.amt;
          data.amt_electricity = data.vendResponse.amt_electricity;
          data.tax = data.vendResponse.tax;
          data.debt = `'${formatAmount(data.vendResponse.debt)}`;
          data.token = `'${formatToken(data.vendResponse.token)}`;
          delete data.vendResponse;
        }
      } else if (data.customer) {
        data.name = data.customer.name || null;
        data.email = data.customer.email || null;
        data.phone = `"${data.customer.phone}"` || null;
        delete data.customer;
      } else {
        const phone = data.user ? data.user.phone : data.phone;
        const customerName = data.facility
          ? data.facility.owner
          : data.user
            ? data.user.name
            : phone;

        data.Phone = phone || null;
        data.Customer_name = customerName;
        data.Meter = `"${data.meter}"`;
        data.Account_name = `"${data.acc_name}"`;
        data.Account_num = `"${data.acc_num}"`;
        data.Bank = `"${data.bank}"`;
        data.ID = `"${data.id}"`;
        data.Disco = `"${data.disco}"`;
        data.Bank_code = `"${data.bank_code}"`;
        data.Reference = `"${data.ref}"`;
      }
    },

    async loadData() {
      const donwloadLimit = 90;
      const data = await this.$parent
        .fetchData(this.page, donwloadLimit);

      await data.forEach(this.formatVendResponse);

      if (!data.length) {
        this.getExportFileName();
        this.isComplete = true;
        return;
      }

      if (this.isVisible) {
        this.payload = [...this.payload, ...data];
        this.page = this.page + 1;
        this.loadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: #edf2f7;
  color: white;
}
.md-dialog /deep/.md-dialog-container {
  min-width: 30%;
}
</style>
